import { Record, List, Map } from 'immutable'
import { handleActions } from 'redux-actions'
import * as actions from './actions'

export const RateUser = Record({
  firstName: null,
  lastName: null,
  avatar: null,
  email: null,
  id: null,
})

export const Rate = Record({
  comment: null,
  createdAt: null,
  proTrack: null,
  rate: null,
  user: new RateUser(),
})

export const Rates = Record({
  list: List(),
  currentLevel: null,
  pagination: Map({
    current: 0,
    perPage: 4,
  }),
  loaded: false,
})

const handleGetRatesSuccess = (state, { payload }) => {
  return state
    .set('list', List(payload.data.map(item => new Rate({ ...item, user: new RateUser(item.user) }))))
    .set('loaded', true)
}

const handleGetRatesFail = (state, { payload }) => {
  return state.set('loaded', true)
}

const handleSelectPage = (state, { payload }) => {
  return state.setIn(['pagination', 'current'], payload.page)
}

export default handleActions(
  {
    [actions.getRates.success]: handleGetRatesSuccess,
    [actions.getRates.fail]: handleGetRatesFail,
    [actions.selectPage]: handleSelectPage,
  },
  new Rates()
)
